import { render, staticRenderFns } from "./ClinicMedicalIcon.vue?vue&type=template&id=9dcf8650"
import script from "./ClinicMedicalIcon.vue?vue&type=script&lang=ts"
export * from "./ClinicMedicalIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports